import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  IGetPayAlertsArgs,
  IGetPayAlertsResponseData,
} from "./getPayAlerts.schema";

export const getPayAlerts = (axios: IAxiosInstance) => {
  return async ({ companyID }: IGetPayAlertsArgs) => {
    const response = await axios.noRetry.get<
      IApiResponse<IGetPayAlertsResponseData>
    >("/api/pay-alerts", {
      params: { companyID },
      withCredentials: true,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
